/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { FadeInEffect } from "./FadeInEffect";
import { PlaylistClip } from "types/Clip";
import { MICRO_FADE_DURATION_MS } from "PhonosConstants";

export class MicroFadeInEffect extends FadeInEffect {
  static canBuildFor(clip: PlaylistClip): boolean {
    return true;
  }

  constructor(
    audioContext: AudioContext,
    clip: PlaylistClip,
    playlistTime: number
  ) {
    super(audioContext, clip, playlistTime, MICRO_FADE_DURATION_MS);
  }
}
